import { useState, useEffect } from "react";

import ProjectCard from "../../components/Project/ProjectCard";

import useScroll from "../../hooks/use-scroll";

import styles from "./Projects.module.css";

import { PROJECT_DATA } from "../../data/projects-data";

const Projects = (props) => {
  const [index, setIndex] = useState(0);
  const [page, setPage] = useState(index);
  const [currentState, setCurrentState] = useState("CREATED");
  const [pos, setPos] = useState(0);

  useEffect(() => {
    document
      .getElementsByClassName(styles["projects-page"])[0]
      .addEventListener("touchmove", (event) => event.preventDefault(), {
        passive: false,
      });
  }, []);

  useEffect(() => {
    if (page === index) {
      setCurrentState("CREATED");
    } else if (currentState === "EXIT") {
      const timer = setTimeout(() => {
        setCurrentState("DESTROYED");
      }, 350);
      return () => {
        clearTimeout(timer);
      };
    } else if (currentState === "DESTROYED") {
      setPage(index);
    } else {
      setCurrentState("EXIT");
    }
  }, [index, page, currentState]);

  const [scrollHandler] = useScroll((direction) => {
    setIndex(
      (prev) => (prev - direction + PROJECT_DATA.length) % PROJECT_DATA.length
    );
  });

  const handleTouchStart = (event) => {
    setPos(event.targetTouches[0].clientY);
  };

  const handleTouchEnd = (event) => {
    const scroll = event.changedTouches[0].clientY - pos;
    if (scroll >= 80) {
      setIndex(
        (prev) => (prev - 1 + PROJECT_DATA.length) % PROJECT_DATA.length
      );
    } else if (scroll <= -80) {
      setIndex(
        (prev) => (prev + 1 + PROJECT_DATA.length) % PROJECT_DATA.length
      );
    }
  };

  return (
    <section
      className={styles["projects-page"]}
      onWheel={scrollHandler}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}>
      <ProjectCard project={PROJECT_DATA[page]} currentState={currentState} />
    </section>
  );
};

export default Projects;
